import { setStoreValue } from "@/store/utils";

export const SET_ORGANISATION_UNITS = "SET_ORGANISATION_UNITS";
export const SET_CLIENT_ORGANISATION_UNITS = "SET_CLIENT_ORGANISATION_UNITS";
export const SET_IS_FETCHING_ORGANISATION_UNITS =
  "SET_IS_FETCHING_ORGANISATION_UNITS";
export const SET_SCOPED_USERS = "SET_SCOPED_USERS";
export const SET_IS_FETCHING_SCOPED_USERS = "SET_IS_FETCHING_SCOPED_USERS";
export const SET_SCOPED_USERS_PREVIEW = "SET_SCOPED_USERS_PREVIEW";
export const SET_IS_FETCHING_SCOPED_USERS_PREVIEW =
  "SET_IS_FETCHING_SCOPED_USERS_PREVIEW";
export const SET_ARCHIVED_UNITS = "SET_ARCHIVED_UNITS";
export const SET_PARENT_UNITS = "SET_PARENT_UNITS";
export const SET_IS_FETCHING_PARENT_UNITS = "SET_IS_FETCHING_PARENT_UNITS";

const mutations = {
  [SET_ORGANISATION_UNITS]: setStoreValue("organisationUnits"),
  [SET_ARCHIVED_UNITS]: setStoreValue("archivedUnits"),
  [SET_CLIENT_ORGANISATION_UNITS]: setStoreValue("clientOrganisationUnits"),
  [SET_IS_FETCHING_ORGANISATION_UNITS]: setStoreValue("isFetchingUnits"),
  [SET_IS_FETCHING_PARENT_UNITS]: setStoreValue("isFetchingParentUnits"),
  [SET_PARENT_UNITS]: setStoreValue("parentUnits"),
  [SET_SCOPED_USERS]: setStoreValue("scopedUsers"),
  [SET_IS_FETCHING_SCOPED_USERS]: setStoreValue("isFetchingScopedUsers"),
  [SET_SCOPED_USERS_PREVIEW]: setStoreValue("scopedUsersPreview"),
  [SET_IS_FETCHING_SCOPED_USERS_PREVIEW]: setStoreValue(
    "isFetchingScopedUsersPreview"
  )
};

const state = {
  organisationUnits: [],
  clientOrganisationUnits: [],
  isFetchingUnits: false,
  scopedUsers: [],
  isFetchingScopedUsers: false,
  scopedUsersPreview: [],
  isFetchingScopedUsersPreview: false,
  archivedUnits: [],
  parentUnits: [],
  isFetchingParentUnits: false
};

export { mutations, state };
